import React, { useState } from "react";
import ButtonBlack from "@shared/uiNew/Button/button_black";
import { IconChevronDown } from "@shared/uiNew/Icons/util";
import * as styles from "./FAQSection.module.scss";

export type FaqItem = {
  question: string;
  answer: string;
};

type Props = {
  items: FaqItem[];
  tag?: string;
  heading?: React.ReactNode;
  subtext?: string;
  ctaText?: string;
  ctaHref?: string;
};

const AccordionItem: React.FC<{
  item: FaqItem;
  isOpen: boolean;
  onClick: () => void;
}> = ({ item, isOpen, onClick }) => (
  <div
    className={`${styles.item} ${isOpen ? styles.itemOpen : ""}`}
    itemScope
    itemProp="mainEntity"
    itemType="https://schema.org/Question"
  >
    <button className={styles.itemBtn} onClick={onClick} type="button">
      <span className={styles.itemQuestion} itemProp="name">
        {item.question}
      </span>
      <span className={styles.itemArrow}>
        <IconChevronDown size={18} />
      </span>
    </button>
    <div className={styles.itemBody}>
      <div
        itemScope
        itemProp="acceptedAnswer"
        itemType="https://schema.org/Answer"
      >
        <p className={styles.itemAnswer} itemProp="text">
          {item.answer}
        </p>
      </div>
    </div>
  </div>
);

export const FAQSection: React.FC<Props> = ({
  items,
  tag = "FAQs",
  heading,
  subtext,
  ctaText = "Book a demo",
  ctaHref,
}) => {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className={styles.section} itemScope itemType="https://schema.org/FAQPage">
      <div className={styles.container}>
        <div className={styles.left}>
          <span className={styles.tag}>{tag}</span>
          <h2 className={styles.heading}>
            {heading ?? (
              <>
                Frequently
                <br />
                asked
                <br />
                questions
              </>
            )}
          </h2>
          {subtext ? <p className={styles.subtext}>{subtext}</p> : null}
          <div className={styles.ctaWrap}>
            <ButtonBlack text={ctaText} icon="arrow" href={ctaHref} />
          </div>
        </div>

        <div className={styles.right}>
          {items.map((item, i) => (
            <AccordionItem
              key={i}
              item={item}
              isOpen={openIndex === i}
              onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
